import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '~/store';

// Base selector
const clanTasksSelector = (state: RootState) => state.ReducerClanTasks;

// Memoized selectors
export const clanTasksIsFetchingSelector = createSelector(clanTasksSelector, (clanTasks) => clanTasks.isFetching);
export const clanTasksIsClaimingSelector = createSelector(clanTasksSelector, (clanTasks) => clanTasks.isClaiming);
export const clanTasksClaimedSelector = createSelector(clanTasksSelector, (clanTasks) => clanTasks.claimed);
export const clanTasksTasksSelector = createSelector(clanTasksSelector, (clanTasks) => clanTasks.tasks);
